// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SequenceNumberListPagingResultModel from '../../model/sequence-number-list-paging-result-model';
import SequenceNumberListPagingResultDTO from '../dto/sequence-number-list-paging-result-dto';
import SequenceNumberListModel from '../../model/sequence-number-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class SequenceNumberListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SequenceNumberListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SequenceNumberListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: SequenceNumberListModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO>): SequenceNumberListPagingResultModel;
  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO> | undefined | null): SequenceNumberListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO> | undefined | null): SequenceNumberListPagingResultModel | undefined {
    return dto ? new SequenceNumberListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SequenceNumberListPagingResultModel> | SequenceNumberListPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as SequenceNumberListPagingResultDTO;
  }
}
